import React from 'react';
import { 
  XMarkIcon,
  CogIcon,
  HandRaisedIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline';

interface ItemSelectionChoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onChooseAutomatic: () => void;
  onChooseManual: () => void;
  proposalNumber?: string;
  itemsCount?: number;
}

const ItemSelectionChoiceModal: React.FC<ItemSelectionChoiceModalProps> = ({
  isOpen,
  onClose,
  onChooseAutomatic,
  onChooseManual,
  proposalNumber,
  itemsCount = 0
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-semibold text-gray-900">
            Seleção de Itens - Proposta Aprovada
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>

        <div className="mb-6">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
            <div className="flex items-center">
              <CheckCircleIcon className="h-4 w-4 text-green-600 mr-2" />
              <div>
                <p className="text-sm font-medium text-green-800">
                  Proposta {proposalNumber} foi aprovada!
                </p>
                <p className="text-xs text-green-600 mt-1">
                  {itemsCount} item(ns) precisam ser alocados para execução
                </p>
              </div>
            </div>
          </div>

          <p className="text-xs text-gray-600 mb-4">
            Como você gostaria de alocar os itens específicos para esta proposta?
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={onChooseAutomatic}
            className="w-full p-4 border-2 border-blue-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-colors text-left"
          >
            <div className="flex items-start">
              <CogIcon className="h-6 w-6 text-blue-600 mr-3 mt-0.5" />
              <div>
                <h4 className="font-medium text-gray-900">Seleção Automática</h4>
                <p className="text-xs text-gray-600 mt-1">
                  O sistema escolherá automaticamente os itens disponíveis com base na disponibilidade e prioridade.
                </p>
                <p className="text-xs text-blue-600 mt-2 font-medium">
                  🤖 Recomendado para agilizar o processo
                </p>
              </div>
            </div>
          </button>

          <button
            onClick={onChooseManual}
            className="w-full p-4 border-2 border-orange-200 rounded-lg hover:border-orange-400 hover:bg-orange-50 transition-colors text-left"
          >
            <div className="flex items-start">
              <HandRaisedIcon className="h-6 w-6 text-orange-600 mr-3 mt-0.5" />
              <div>
                <h4 className="font-medium text-gray-900">Seleção Manual</h4>
                <p className="text-xs text-gray-600 mt-1">
                  Você escolherá manualmente quais itens específicos serão alocados para o cliente.
                </p>
                <p className="text-xs text-orange-600 mt-2 font-medium">
                  👤 Para controle total sobre a alocação
                </p>
              </div>
            </div>
          </button>
        </div>

        <div className="mt-6 pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="w-full bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300 text-sm"
          >
            Cancelar (manter em negociação)
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemSelectionChoiceModal;